import Logger from '../Log'
import StartEventHook from './StartEventHook'

const Log = Logger.for('InstreamHook')

export default class NativoStartHook extends StartEventHook {
  constructor () {
    super('InstreamHook')
  }

  async run (remoteConfig) {
    if (!remoteConfig.contentUrl()) return Log.debug('No content url provided, sticking to outstream')

    const v = remoteConfig.media().video
    if (!v) {
      return Log.warn('contentUrl provided but video not enabled for placement!')
    }

    v.context = 'instream'
    v.contentUrl = remoteConfig.contentUrl() // inject so we may use later

    const opts = remoteConfig.prebidOpts()
    opts.cache = {
      // required for instream? bs or prebid discards bids!
      url: 'https://prebid.adnxs.com/pbc/v1/cache'
    }

    console.log(opts)
    Log.info('contentUrl provided - video placement marked as instream')
  }
}
